//IB WALLET BALANCE

import api from "../utils/axiosInstance.js";
import { GET_WALLET_LIST, GET_WALLET_LIST_ERROR, GET_WALLET_LIST_REQUEST, UPDATE_WALLET_LIST_DATA, REMOVE_WALLET_LIST_DATA } from "../ActionTypes/ActionTypes.js";

const getWalletRequest = () => ({ type: GET_WALLET_LIST_REQUEST });
const getWalletSuccess = (data) => ({ type: GET_WALLET_LIST, payload: data });
const getWalletError = (error) => ({ type: GET_WALLET_LIST_ERROR, payload: error });

export const getWalletList = (data) => async (dispatch) => {
    dispatch(getWalletRequest());
    try {
        const response = await api.post(`/wallet/getadminwalletlist`, data);
        if (response.data.success) {
            dispatch(getWalletSuccess(response.data?.data));
        }
        else {
            dispatch(getWalletError(response?.data?.message));
        }
    } catch (error) {
        dispatch(getWalletError(error.response?.data?.message || error.message));
    }
};

export const updateWalletListData = (newData) => ({
    type: UPDATE_WALLET_LIST_DATA,
    payload: newData,
});


export const removeWalletListData = (newData) => ({
    type: REMOVE_WALLET_LIST_DATA,
    payload: newData,
});
